<template>
  <div>
    搜索:
    <el-tag
      :key="tag.title"
      v-for="tag in dynamicTags"
      closable
      :disable-transitions="false"
      effect="dark"
      size="large"
      @close="handleClose(tag)"
    >
      {{ tag.title }}
    </el-tag>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dynamicTags: [],
    }
  },
  methods: {
    handleClose(tag) {
      for (let i = 0; i < this.dynamicTags.length; i++) {
        if (this.dynamicTags[i].key === tag.key) {
          this.dynamicTags.splice(i, 1)
        }
      }
      this.$emit('searchList', this.dynamicTags)
    },
    setTag(object) {
      //計算陣列內是否有依樣的篩選，一個篩選只能選一個
      if (this.dynamicTags.length !== 0) {
        for (let i = 0; i < this.dynamicTags.length; i++) {
          if (this.dynamicTags[i].key === object.key) {
            this.dynamicTags.splice(i, 1)
          }
        }
      }
      this.dynamicTags.push(object)
      this.$emit('searchList', this.dynamicTags)
    },
  },
}
</script>
<style scoped>
.el-tag {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/element_ui/filter_componet/Tag.vue